import React from "react";
import { Tooltip } from "antd";
import {
  HistoryOutlined,
  CalculatorOutlined,
  DownOutlined,
  RightOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import dineroDisabledMask from "../../../../../Components/dineroDisabledMask";

const thStyle = {
  padding: "6px 10px",
  background: "#f5f5f5",
  fontWeight: 600,
  fontSize: 11,
  color: "#374151",
  borderBottom: "1px solid #e5e7eb",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  zIndex: 1,
  textAlign: "left",
};

const tdStyle = (align = "left") => ({
  padding: "5px 10px",
  fontSize: 12,
  color: "#111827",
  borderBottom: "1px solid #f3f4f6",
  textAlign: align,
  whiteSpace: "nowrap",
});

const formatearFecha = (iso) => {
  if (!iso) return "-";
  const fecha = new Date(iso);
  return fecha.toLocaleDateString("es-MX", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Historial de costos del insumo. Al abrirse por una equivalencia el backend ya divide cada
// costo entre el factor, asi que las cifras estan en la misma unidad que el resto del modal.
// "Usar" no elige precio: carga ese costo en la calculadora para simular con el costo viejo.
//
// La moneda va en el encabezado de la columna y no renglon por renglon: Insumo.historialCostos[]
// no guarda moneda propia (a diferencia de relaciones[].historialCostos[]), todos los renglones
// estan en Insumo.monedaId. Mismo criterio que HistorialInsumoClienteModal, que solo saca la
// columna de moneda cuando de verdad hay mas de una.
const HistorialCostos = ({
  historial,
  moneda,
  abierto,
  onToggle,
  fechaSeleccionada,
  onUsar,
}) => {
  const lista = Array.isArray(historial) ? historial : [];

  return (
    <div style={{ marginTop: 16 }}>
      <div
        onClick={onToggle}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          cursor: "pointer",
          userSelect: "none",
          padding: "6px 0",
        }}
      >
        {abierto ? (
          <DownOutlined style={{ fontSize: 10, color: "#9ca3af" }} />
        ) : (
          <RightOutlined style={{ fontSize: 10, color: "#9ca3af" }} />
        )}
        <HistoryOutlined style={{ fontSize: 13, color: "#6b7280" }} />
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#6b7280",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          Historial de costos
        </span>
        <span style={{ fontSize: 11, color: "#9ca3af" }}>({lista.length})</span>
      </div>

      {abierto && (
        <div
          style={{
            maxHeight: 240,
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Fecha</th>
                <th style={{ ...thStyle, textAlign: "right" }}>
                  Costo ({moneda || "MXN"})
                </th>
                <th style={{ ...thStyle, width: 90 }} />
              </tr>
            </thead>
            <tbody>
              {lista.length === 0 ? (
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      padding: 16,
                      color: "#9ca3af",
                      fontSize: 12,
                    }}
                  >
                    No hay historial disponible
                  </td>
                </tr>
              ) : (
                lista.map((h, idx) => {
                  const enUso = fechaSeleccionada === h.fecha;
                  return (
                    <tr
                      key={h._id || idx}
                      style={{
                        background: enUso
                          ? "#f9f0ff"
                          : idx % 2 === 0
                          ? "#fff"
                          : "#fafafa",
                      }}
                    >
                      <td style={{ ...tdStyle(), color: "#6b7280" }}>
                        {formatearFecha(h.fecha)}
                      </td>
                      <td style={{ ...tdStyle("right"), fontWeight: 600 }}>
                        {dineroDisabledMask(h.costo)}
                      </td>
                      <td style={tdStyle("right")}>
                        {enUso ? (
                          <span
                            style={{
                              fontSize: 11,
                              color: "#722ed1",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                            }}
                          >
                            <CheckCircleFilled style={{ marginRight: 4 }} />
                            En uso
                          </span>
                        ) : (
                          <Tooltip title="Simular la calculadora con este costo">
                            <span
                              onClick={() => onUsar(h)}
                              style={{
                                fontSize: 11,
                                color: "#00BFD6",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <CalculatorOutlined style={{ marginRight: 4 }} />
                              Usar
                            </span>
                          </Tooltip>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default HistorialCostos;
